import { render, staticRenderFns } from "./kpsrDetail.vue?vue&type=template&id=8addf3ca"
import script from "./kpsrDetail.vue?vue&type=script&lang=js"
export * from "./kpsrDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8addf3ca')) {
      api.createRecord('8addf3ca', component.options)
    } else {
      api.reload('8addf3ca', component.options)
    }
    module.hot.accept("./kpsrDetail.vue?vue&type=template&id=8addf3ca", function () {
      api.rerender('8addf3ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kpsr/kpsrDetail.vue"
export default component.exports